import React, { useEffect, useState } from "react";
import { Box, Flex, Text, VStack } from "@chakra-ui/react";
import { ContentControls } from "./ContentControls";
import { useFocus } from "./useFocus";
import { PimcoreDocument } from "./PimcoreDocument";
import { useContentManagement, useSnippetResolver } from "./ContentManagementProvider";
import { ContentArea } from "./ContentArea";
import InnerHTML from 'dangerously-set-html-content';
const defaults = {
    documentId: null
};
function isSnippet(element) {
    return element.type === "snippet";
}
export const SnippetContentElement = (props) => {
    const [ref, setRef] = useState(null);
    const [html, setHtml] = useState(null);
    const [contentElements, setContentElements] = useState(null);
    const { containerProps, isActive } = useFocus(props.contentElement.id);
    const resolver = useSnippetResolver();
    const { isEditing } = useContentManagement();
    useEffect(() => {
        if (!isSnippet(props.contentElement) || props.contentElement.data == null) {
            const element = Object.assign(Object.assign({}, props.contentElement), { type: "snippet", data: defaults });
            props.onChange(element);
            return;
        }
    }, [props.contentElement]);
    useEffect(() => {
        var _a;
        if (isSnippet(props.contentElement) && typeof ((_a = props.contentElement.data) === null || _a === void 0 ? void 0 : _a.documentId) === "number") {
            resolver(props.contentElement.data.documentId).then((data) => {
                try {
                    const parse = JSON.parse(data);
                    setContentElements(parse);
                    setHtml(null);
                }
                catch (e) {
                    setHtml(data);
                    setContentElements(null);
                }
            });
        }
    }, [props.contentElement]);
    if (!isSnippet(props.contentElement) || props.contentElement.data == null) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Flex, Object.assign({ ref: setRef }, containerProps),
        ref && isActive &&
            React.createElement(ContentControls, { onUp: props.onUp, onDown: props.onDown, onDelete: props.onDelete, label: "Snippet", attachTo: ref },
                React.createElement(PimcoreDocument, { documentId: props.contentElement.data.documentId, onChange: (documentId) => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { documentId }) })) })),
        React.createElement(Box, { flex: 1 },
            isEditing &&
                React.createElement(VStack, { w: "100%", bg: "gray.50", borderColor: "gray.100", borderRadius: "md", borderWidth: 1, p: 6, alignItems: "center" },
                    React.createElement(Text, null, "Snippet")),
            html && !isEditing && React.createElement(InnerHTML, { html: html }),
            contentElements && !isEditing &&
                React.createElement(ContentArea, { contentElements: contentElements, onChange: () => undefined, allowedTypes: [], showAdd: false, attachControlsTo: null }))));
};
